import { render } from "./ProductRecommendationServiceParameter.vue?vue&type=template&id=b4faaa16&scoped=true"
import script from "./ProductRecommendationServiceParameter.vue?vue&type=script&lang=ts"
export * from "./ProductRecommendationServiceParameter.vue?vue&type=script&lang=ts"

import "./ProductRecommendationServiceParameter.vue?vue&type=style&index=0&id=b4faaa16&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b4faaa16"

export default script